import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import s from './PublishInstructions.module.scss';

const PublishTooltip = ({ isVisible, status, stopDate }) => {
    if (status === 'SUCCEEDED' && isVisible) return null;
    const isUnknown = !stopDate || stopDate === 'UNKNOWN';
    let lastPublishText = 'No recent successful publish';
    if (!isUnknown) {
        const m = moment(stopDate);
        lastPublishText = m.isValid() ? `Last successful publish: ${m.fromNow()}` : 'Last successful publish date unavailable';
    }

    return (
        <span className={s.tooltip}>
            <img src="https://content.locuslabs.com/vms-ui/publish-ui-icons/tooltip.svg" alt="Tooltip" />
            <span className={s.tooltipText}>{lastPublishText}</span>
        </span>
    );
};

PublishTooltip.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    stopDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]).isRequired,
};

export default PublishTooltip;
